<template>
  <div class="paiwei-redesign-page">
    <Header class="paiwei-legacy-header"></Header>
    <header class="paiwei-redesign-header" v-if="gameState === 'matching' || gameState === 'playing'">
      <button class="paiwei-redesign-back" type="button" :aria-label="$t('Back')" @click="$router.go(-1)">
        <img src="../../static/images/livequiz/back.png" alt="">
      </button>
    </header>
    <!-- 状态显示 -->
    <!-- <div class="status-bar">
      <div>连接状态：<span>{{ connectionStatus }}</span></div>
      <div>房间号：<span>{{ roomId || '-' }}</span></div>
      <div>我的等级：Lv.<span>{{ playerInfo.level || '-' }}</span></div>
    </div> -->

    <!-- 匹配等待 -->

    <section class="paiwei-matching-screen" v-if="gameState === 'matching'">
      <img class="paiwei-page-title" src="../../static/images/ranked_mode_title.png" :alt="$t('game2T2')">
      <div class="paiwei-matching-panel">
        <img class="paiwei-matching-panel-bg" src="../../static/images/ai_training/ai_training_bg.png" alt="">
        <div class="paiwei-matching-panel-content">
          <h2>{{$t('RobotMatchMaking')}}...</h2>
          <div class="paiwei-match-players">
            <div class="paiwei-match-player">
              <img :src="playerInfo.avatar || '../../static/images/default-avatar.png'" alt="">
              <strong>{{ playerInfo.nickname }}</strong>
            </div>
            <div class="paiwei-match-vs"><img src="../../static/images/pk/VS.png" alt="VS"></div>
            <div class="paiwei-match-player paiwei-match-player--waiting">
              <img src="../../static/images/wait-avatar.png" alt="">
              <strong>{{ formatOpponentNickname(opponentInfo.nickname) }}</strong>
            </div>
          </div>
          <p>{{$t('MatchingLevel')}}: Lv.{{ matchLevelRange }}</p>
          <p>{{$t('Waiting')}}: {{ waitTime }}s</p>
        </div>
      </div>
    </section>

    <!-- 对战面板 -->
    <section class="paiwei-battle-screen" v-if="gameState === 'playing'">
      <img class="paiwei-page-title paiwei-battle-title" src="../../static/images/ranked_mode_title.png" :alt="$t('game2T2')">

      <!-- 新增倒计时特效 -->
      <div v-if="countdownVisible" class="countdown-overlay">
        <img class="countdown-number" :key="countdownNumber" :src="'static/images/livequiz/ready/' + countdownNumber + '.png'" :alt="countdownNumber">
      </div>

      <div class="paiwei-score-board">
        <div class="paiwei-score-player paiwei-score-player--you">
          <strong class="paiwei-score-name">{{ playerInfo.nickname }}</strong>
          <div class="paiwei-score-track" :style="{ '--score-rate': (Math.max(0, Math.min(1, Number(scores.your_score_rate) || 0)) * 100) + '%' }">
            <i></i>
            <span class="paiwei-score-value"><em>{{ scores.player }}</em><b>{{$t('LiveQuizPts')}}</b></span>
          </div>
          <img :src="playerInfo.avatar || '../../static/images/default-avatar.png'" alt="">
        </div>
        <div class="paiwei-score-player paiwei-score-player--opponent">
          <strong class="paiwei-score-name">{{ formatOpponentNickname(opponentInfo.nickname) }}</strong>
          <div class="paiwei-score-track" :style="{ '--score-rate': (Math.max(0, Math.min(1, Number(scores.opponent_score_rate) || 0)) * 100) + '%' }">
            <i></i>
            <span class="paiwei-score-value"><em>{{ scores.opponent }}</em><b>{{$t('LiveQuizPts')}}</b></span>
          </div>
          <img :src="opponentInfo.avatar || '../../static/images/default-avatar.png'" alt="">
        </div>
      </div>
      <div class="paiwei-question-card" v-if="!countdownVisible">
        <div class="paiwei-question-timer" :style="{ '--timer-progress': (timeTotal ? Math.max(0, (timeTotal - timeLeft) / timeTotal * 360) : 0) + 'deg' }">
          <strong>{{ timeLeft }}</strong>
        </div>
        <div class="paiwei-question-number" v-if="currentQuestionIndex">{{$t('Question')}} {{ currentQuestionIndex }}</div>
        <h2 class="paiwei-question-title">{{ currentQuestion }}</h2>
        <div class="paiwei-answer-list">
            <button
              v-for="(option, key) in currentOptions"
              :key="key"
              class="paiwei-answer-option"
              :class="{
                'correct': answerRevealed && key === correctAnswer,
                'wrong': answerRevealed && selectedAnswer === key && key !== correctAnswer
              }"
              :disabled="answerRevealed || isAnswerSubmitted"
              @click="selectAnswer(key)"
            >
              <span class="paiwei-answer-text">{{ option }}</span>
              <img v-if="answerRevealed && key === correctAnswer" src="../../static/images/Correct.png" alt="">
              <img v-else-if="answerRevealed && selectedAnswer === key && key !== correctAnswer" src="../../static/images/Wrong.png" alt="">
            </button>
        </div>
      </div>
    </section>

    <div class="paiwei-result-popup" v-if="gameState === 'ended'">
      <div class="paiwei-result-popup-mask"></div>
      <section class="paiwei-result-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('GameOver')">
        <div class="paiwei-result-popup-header">
          <img src="../../static/images/win_lose/pop_up_header.png" alt="">
          <h2 v-if="gameResult === 'win'">{{ $t('GameWinTitle') }}</h2>
          <h2 v-else-if="gameResult === 'lose'">{{ $t('GameLoseTitle') }}</h2>
          <h2 v-else>{{ $t('GameDrawTitle') }}</h2>
        </div>
        <div class="paiwei-result-popup-card">
          <img class="paiwei-result-popup-card-bg" src="../../static/images/win_lose/pop_up_bg.png" alt="">
          <div class="paiwei-result-popup-content">
            <p class="paiwei-result-message" v-if="gameResult === 'win'"><strong>{{ $t('GameWinLead') }}</strong> {{ $t('GameWinMessage') }}</p>
            <p class="paiwei-result-message" v-else-if="gameResult === 'lose'"><strong>{{ $t('GameLoseLead') }}</strong> {{ $t('GameLoseMessage') }}</p>
            <p class="paiwei-result-message" v-else>{{ $t('GameDrawMessage') }}</p>
            <img v-if="gameResult === 'win'" class="paiwei-result-hero" src="../../static/images/win_lose/win.png" alt="">
            <img v-else-if="gameResult === 'lose'" class="paiwei-result-hero" src="../../static/images/win_lose/lose.png" alt="">
            <img v-else class="paiwei-result-hero" src="../../static/images/win_lose/quiz_over.png" alt="">
            <div class="paiwei-result-scores">
              <img src="../../static/images/win_lose/score_bg.png" alt="">
              <div class="paiwei-result-score">
                <span>{{ $t('YourScore') }}</span>
                <div class="paiwei-result-score-number"><img src="../../static/images/home/pts.png" alt=""><strong>{{ scores.player }}</strong></div>
              </div>
              <div class="paiwei-result-score">
                <span>{{ $t('OpponentScore') }}</span>
                <div class="paiwei-result-score-number"><img src="../../static/images/home/pts.png" alt=""><strong>{{ scores.opponent }}</strong></div>
              </div>
            </div>
            <div class="paiwei-result-actions">
              <button type="button" @click="$router.push({path:'/quizCenter'})"><img src="../../static/images/win_lose/back.png" alt=""><span>{{ $t('Back') }}</span></button>
              <button type="button" @click="startMatch"><img src="../../static/images/win_lose/play_again.png" alt=""><span>{{ $t('PlayAgain') }}</span></button>
            </div>
          </div>
        </div>
        <button class="paiwei-result-close" type="button" :aria-label="$t('Back')" @click="$router.push({path:'/quizCenter'})"><img src="../../static/images/buy_more/close.png" alt=""></button>
      </section>
    </div>


    <div class="paiwei-buy-popup" v-if="showBuyMorePopup">
      <div class="paiwei-buy-popup-mask" @click="cancelOtpDialog"></div>
      <section class="paiwei-buy-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('BuyChances')">
        <div class="paiwei-buy-popup-header">
          <img src="../../static/images/buy_more/pop_up_header.png" alt="">
          <h2>{{ $t('BuyChances') }}</h2>
        </div>
        <div class="paiwei-buy-popup-card">
          <img class="paiwei-buy-popup-card-bg" src="../../static/images/buy_more/buy_chance_pop_up_bg.png" alt="">
          <div class="paiwei-buy-popup-content">
            <p>
              <span>{{ $t('BuyMoreChancesCopy') }}</span>
              <span>{{ $t('BuyMoreChancesWin') }} <strong>{{ $t('BuyMoreChancesHighlight') }}</strong></span>
            </p>
            <img class="paiwei-buy-popup-hero" src="../../static/images/buy_more/buy_chance_photo.png" alt="">
            <button class="paiwei-buy-popup-option" type="button" @click="getSubmit">
              <img class="paiwei-buy-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
              <img src="../../static/images/buy_more/one_time_purchase.png" :alt="$t('one_time_purchase')">
              <span>{{ $t('one_time_purchase') }}</span>
            </button>
            <div class="paiwei-buy-popup-balance">
              <span>{{ $t('CurrentChances') }}</span>
              <img src="../../static/images/home/chance.png" alt="">
              <strong>{{ remainingChances }}</strong>
            </div>
          </div>
        </div>
        <button class="paiwei-buy-popup-close" type="button" :aria-label="$t('Later')" @click="cancelOtpDialog">
          <img src="../../static/images/buy_more/close.png" alt="">
        </button>
      </section>
    </div>

  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
import AudioService from '@/services/AudioService'
export default {
    components:{
		Header,Dialog
    },
  name: 'KnowledgeBattle',
  data() {
    return {
      ws: null,
      connectionStatus: 'Not connected',
      gameState: 'connecting', // connecting, matching, playing, ended
      playerInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      opponentInfo: {
        user_id: null,
        nickname: 'Finding',
        avatar: '',
        level: null
      },
      roomId: null,
      matchLevelRange: '0',
      waitTime: 0,
      matchTimer: null,
      currentQuestionIndex: 0,
      totalQuestions: 0,
      currentQuestion: '',
      currentOptions: {},
      correctAnswer: null,
      selectedAnswer: null,
      answerRevealed: false,
      isAnswerSubmitted: false,
      scores: {
        player: 0,
        opponent: 0
      },
      timeLeft: 0,
      timeTotal: 10,
      timerInterval: null,
      circumference: 2 * Math.PI * 68, // 圆形进度条周长
      gameResult: null, // win, lose, draw

      // 新增倒计时相关数据
      countdownVisible: false,
      countdownNumber: 3,
      //音效
      audioService: AudioService,
      isBgmPlaying: false,
      showBuyMorePopup: false,
      remainingChances: Number(localStorage.getItem('info')) || 0
    }
  },
  created() {
    this.connect();
  },
  mounted(){
    this.audioService.init();
    this.startBackgroundMusic();
  },
  beforeDestroy() {
    this.disconnect();
    this.stopBackgroundMusic();
  },
  methods: {
    formatOpponentNickname(nickname) {
      const value = String(nickname || '');
      return /^\+?\d{7,15}$/.test(value)
        ? value.replace(/^(\+?\d{3})\d+(\d{2})$/, '$1****$2')
        : value;
    },
    connect() {
      this.ws = new WebSocket('wss://battle.goquizgo.com/ws');

      this.ws.onopen = () => {
        this.connectionStatus = 'WebSocket connected';
        this.ws.send(JSON.stringify({
          match_type: 'rank',
          action: 'login',
          mobile: localStorage.getItem('mobile')
        }));
      };

      this.ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        this.handleMessage(data);
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        this.connectionStatus = 'WebSocket error';
      };

      this.ws.onclose = () => {
        console.log('WebSocket closed');
        this.connectionStatus = 'WebSocket closed';
      };
    },

    disconnect() {
      if (this.ws) {
        this.ws.close();
      }
      this.clearTimers();
    },

    clearTimers() {
      if (this.matchTimer) {
        clearInterval(this.matchTimer);
        this.matchTimer = null;
      }
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    handleMessage(data) {
      if (data.match_type !== 'rank'){
        return;
      }
      switch(data.action) {
        case 'login_success':
          this.handleLoginSuccess(data);
          break;
        case 'chance_error':
          this.handleChanceError(data);
          break;
        case 'match_waiting':
          this.showMatchPanel(data);
          break;
        case 'enter_room':
          this.startGame(data);
          break;
        case 'new_question':
          this.showQuestion(data);
          break;
        case 'answer_result':
          this.handleAnswerResult(data);
          break;
        case 'game_over':
          this.endGame(data);
          break;
        case 'timeout':
          this.playSound('basic.wrong')
          break;
        //断开重连
        case 'reconnect_room':
          this.handleReconnect(data);
      }
    },

    handleLoginSuccess(data) {
      this.playerInfo = {
        user_id: data.data.user_id,
        nickname: data.data.nickname,
        avatar: data.data.avatar,
        level: data.data.level
      };
      this.startMatch();
    },

    startMatch() {
      this.clearTimers();
      this.gameState = 'matching';
      this.waitTime = 0;
      this.scores = { player: 0, opponent: 0 };
      this.matchTimer = setInterval(() => {
        this.waitTime++;
      }, 1000);

      this.ws.send(JSON.stringify({
        match_type: 'rank',
        action: 'start_match'
      }));
    },

    showMatchPanel(data) {
      this.matchLevelRange = data.data.level;
    },

    startGame(data) {
      this.clearTimers();

      this.timeTotal = 3;
      this.timeLeft = 3;
      this.startTimer();

      this.startCountDown();

      this.gameState = 'playing';
      this.roomId = data.room_id;

      // 确定玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;

      if (player1.user_id === this.playerInfo.user_id) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }
    },

    showQuestion(data) {
      this.currentQuestionIndex = data.question_no;
      this.totalQuestions = data.question_count;
      this.currentQuestion = data.question;
      this.currentOptions = data.options;
      this.timeTotal = data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;

      this.startTimer();
    },

    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      this.timerInterval = setInterval(() => {
        this.timeLeft--;

        if (this.timeLeft <= 0) {
          clearInterval(this.timerInterval);
          this.disableOptions();
        }
      }, 1000);
    },

    selectAnswer(answerKey) {
      this.startBackgroundMusic()
      this.selectedAnswer = answerKey;
      this.isAnswerSubmitted = true;

      this.ws.send(JSON.stringify({
        match_type: 'rank',
        action: 'submit_answer',
        room_id: this.roomId,
        question_no: this.currentQuestionIndex,
        answer: answerKey
      }));
    },

    handleAnswerResult(data) {
      if (data.user_id === this.playerInfo.user_id) {
        this.scores.player = data.your_score;
        this.scores.opponent = data.opponent_score;
        this.scores.your_score_rate = data.your_score_rate;
        this.scores.opponent_score_rate = data.opponent_score_rate;
        this.correctAnswer = data.correct_answer;
        this.answerRevealed = true;
        if (data.is_correct){
          //答对
          this.playSound('basic.correct')
        }else {
          //答错
          this.playSound('basic.wrong')
        }
      } else {
        this.scores.opponent = data.your_score;
        this.scores.opponent_score_rate = data.your_score_rate;
      }
    },

    disableOptions() {
      this.isAnswerSubmitted = true;
    },

    endGame(data) {
      this.clearQuestion();
      this.clearTimers();
      this.gameState = 'ended';
      this.updateGameResult(data)
    },

    updateGameResult(data) {
      const results = data.results;
      const maxScore = Math.max(...results.map(player => player.score));
      const winners = results.filter(player => player.score === maxScore);
      const currentPlayer = results.find(player => player.user_id === this.playerInfo.user_id);

      if (!currentPlayer) {
        this.gameResult = null;
      } else if (currentPlayer.score === maxScore) {
        this.gameResult = winners.length > 1 ? 'draw' : 'win';
        this.playSound('sfx.win')
      } else {
        this.gameResult = 'lose';
        this.playSound('sfx.lose')
      }

      this.scores.player = currentPlayer.score;
      this.scores.opponent = results.find(player => player.user_id !== this.playerInfo.user_id).score;
    },
    clearQuestion(){
      this.currentQuestionIndex = 0;
      this.totalQuestions = 0;
      this.currentQuestion = "";
      this.currentOptions = {};
      this.timeTotal = 10;
      this.timeLeft = 0;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
      //清除对手信息
      this.opponentInfo.user_id = null;
      this.opponentInfo.nickname = 'Finding';
      this.opponentInfo.avatar = '';
      this.opponentInfo.level = null;
    },
    //恢复链接
    handleReconnect(data){
      this.roomId = data.room_id;
      //恢复玩家信息
      this.playerInfo = {
        user_id: data.playerInfo.user_id,
        nickname: data.playerInfo.nickname,
        avatar: data.playerInfo.avatar,
        level: data.playerInfo.level
      };
      //恢复玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;
      if (player1.user_id === this.playerInfo.user_id) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }
      //恢复分数信息
      this.scores.player = data.opponent_score.your_score;
      this.scores.opponent = data.opponent_score.opponent_score;
      this.scores.your_score_rate = data.opponent_score.your_score_rate;
      this.scores.opponent_score_rate = data.opponent_score.opponent_score_rate;
      //恢复题目
      this.currentQuestionIndex = data.question_data.question_no;
      this.totalQuestions = data.question_data.question_count;
      this.currentQuestion = data.question_data.question;
      this.currentOptions = data.question_data.options;
      this.timeTotal = data.question_data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.startTimer();
      //恢复答题结果
      this.isAnswerSubmitted = data.current_question_result.isAnswerSubmitted;
      this.selectedAnswer = data.current_question_result.user_answer;
      if (data.current_question_result.user_answer){
        this.correctAnswer = data.current_question_result.correctAnswer;
        this.answerRevealed = true;
      }
      this.gameState = 'playing';
    },
    handleChanceError(data){
      let that =this;
      that.gameState = 'connecting'
      that.showBuyMorePopup = true;
      that.refreshRemainingChances();
    },
    cancelOtpDialog(){
      this.showBuyMorePopup = false;
      this.$router.push({path:'/quizCenter'});
    },
    refreshRemainingChances(){
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function(){
          that.remainingChances = Number((r.data || {}).score) || 0;
          localStorage.setItem('info', that.remainingChances);
        });
      });
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.showBuyMorePopup = false;
            that.remainingChances = Number(localStorage.getItem('info')) || 0;
            that.$utils.alertText(r.msg,80, 800);
            that.startMatch();
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    startCountDown(){
      // 启动3秒倒计时特效
      this.countdownVisible = true;
      this.countdownNumber = 3;
      this.playSound('sfx.countdown')
      const countdownInterval = setInterval(() => {
        this.countdownNumber -= 1;
        if (this.countdownNumber <= 0) {
          clearInterval(countdownInterval);
          this.countdownVisible = false;
        }
      }, 1000);
    },
    playSound(soundName) {
      this.audioService.play(soundName)
        .then(() => console.log(`${soundName} 播放成功`))
        .catch(e => console.error(`${soundName} 播放失败:`, e));
    },
    startBackgroundMusic() {
      // 如果正在播放，则不再重复播放
      if (this.isBgmPlaying) {
        console.log('背景音乐已在播放中');
        return;
      }
      this.audioService.play('bgm.main', { loop: true })
        .then(() => {
          this.isBgmPlaying = true;
          console.log('背景音乐开始播放');
        })
        .catch(e => {
          console.error('背景音乐播放失败:', e);
          this.isBgmPlaying = false;
        });
    },
    stopBackgroundMusic() {
      this.audioService.stopBackground();
      console.log('背景音乐已停止');
    }
  }
}
</script>

<style scoped>
.countdown-overlay { position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(5,0,25,.28); display:flex; justify-content:center; align-items:center; z-index:9999; pointer-events:none; }
.countdown-number { display:block; width:min(64vw,430px); height:min(48vh,430px); object-fit:contain; filter:drop-shadow(0 16px 35px rgba(255,84,180,.22)); animation:countdownPop .8s cubic-bezier(.25,.46,.45,.94) both; }

.paiwei-redesign-page { position:relative; min-height:100vh; box-sizing:border-box; isolation:isolate; padding:46px 28px 96px; overflow-x:hidden; color:#fff; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; font-family:Arial,Atom-sans,sans-serif; }
.paiwei-redesign-page::before { position:absolute; z-index:0; inset:0; content:''; background:rgba(7,0,26,.2); pointer-events:none; }
.paiwei-legacy-header { display:none; }
.paiwei-redesign-header { position:absolute; z-index:20; top:46px; right:0; left:0; width:calc(100% - 56px); max-width:650px; margin:0 auto; }
.paiwei-redesign-back { display:flex; width:72px; height:72px; align-items:center; justify-content:center; padding:0; border:0; background:transparent; cursor:pointer; }
.paiwei-redesign-back img { display:block; width:100%; height:100%; object-fit:contain; }

.paiwei-matching-screen,.paiwei-battle-screen { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.paiwei-page-title { display:block; width:min(78%,520px); margin:0 auto 58px; }
.paiwei-matching-panel { position:relative; width:100%; aspect-ratio:1046 / 1420; overflow:hidden; }
.paiwei-matching-panel-bg { position:absolute; inset:0; display:block; width:100%; height:100%; }
.paiwei-matching-panel-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:13% 10% 9%; text-align:center; }
.paiwei-matching-panel-content h2 { margin:0; color:#fff; font-size:clamp(22px,6vw,40px); font-weight:800; line-height:1; }
.paiwei-match-players { display:flex; width:100%; align-items:center; justify-content:space-between; margin:10% 0 11%; }
.paiwei-match-player { display:flex; width:31%; align-items:center; flex-direction:column; gap:10px; color:#fff; font-size:clamp(13px,3.5vw,23px); line-height:1; }
.paiwei-match-player > img { display:block; width:100%; aspect-ratio:1; box-sizing:border-box; border:3px solid rgba(255,255,255,.95); border-radius:50%; object-fit:cover; background:#fff; }
.paiwei-match-player--waiting > img { object-fit:cover; }
.paiwei-match-vs { display:flex; width:25%; align-items:center; justify-content:center; }
.paiwei-match-vs img { display:block; width:100%; max-width:95px; height:auto; object-fit:contain; }
.paiwei-matching-panel-content p { margin:3px 0; color:#fff; font-size:clamp(15px,4vw,27px); font-weight:600; line-height:1.25; }

.paiwei-battle-screen { padding-top:0; }
.paiwei-battle-title { margin-bottom:46px; }
.paiwei-score-board { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:32px; align-items:end; margin:0 -4px 76px; }
.paiwei-score-player { position:relative; display:block; min-height:116px; overflow:visible; color:#fff; background:transparent; }
.paiwei-score-name { position:absolute; z-index:3; top:0; max-width:58%; overflow:hidden; font-size:clamp(16px,4.5vw,31px); font-weight:500; line-height:1; text-overflow:ellipsis; white-space:nowrap; }
.paiwei-score-track { position:absolute; right:0; bottom:0; left:0; display:flex; min-height:66px; align-items:center; overflow:hidden; box-sizing:border-box; border:2px solid rgba(255,255,255,.9); border-radius:999px; background:rgba(7,2,36,.82); }
.paiwei-score-track > i { position:absolute; top:0; bottom:0; left:0; z-index:0; width:var(--score-rate); background:#08d91d; }
.paiwei-score-value { position:relative; z-index:1; display:flex; align-items:baseline; gap:4px; color:#fff; }
.paiwei-score-value em { font-size:clamp(28px,7vw,48px); font-style:italic; font-weight:900; line-height:.9; }
.paiwei-score-value b { font-size:clamp(14px,3.5vw,24px); font-weight:800; line-height:1; }
.paiwei-score-player > img { position:absolute; bottom:0; z-index:2; display:block; width:110px; height:110px; border:4px solid #fff; border-radius:50%; object-fit:cover; background:#16034d; }
.paiwei-score-player--you { text-align:left; }
.paiwei-score-player--you .paiwei-score-name { left:42%; }
.paiwei-score-player--you .paiwei-score-track { left:35px; padding-left:35%; }
.paiwei-score-player--you > img { left:0; }
.paiwei-score-player--opponent { text-align:right; }
.paiwei-score-player--opponent .paiwei-score-name { right:42%; }
.paiwei-score-player--opponent .paiwei-score-track { right:35px; justify-content:flex-end; padding-right:35%; }
.paiwei-score-player--opponent > img { right:0; }
.paiwei-score-player--opponent .paiwei-score-track > i { right:0; left:auto; }

.paiwei-question-card { position:relative; display:flex; width:100%; min-height:780px; box-sizing:border-box; flex-direction:column; padding:17% 7.2% 11.5%; background:transparent url('../../static/images/livequiz/start/quiz_bg.png') center/100% 100% no-repeat; color:#171722; }
.paiwei-question-timer { --timer-progress:0deg; position:absolute; z-index:2; top:-66px; left:50%; display:flex; width:148px; height:148px; align-items:center; justify-content:center; border-radius:50%; background:conic-gradient(#f3164c 0deg,#f3164c var(--timer-progress),#4378da var(--timer-progress),#4378da 360deg); box-shadow:0 4px 12px rgba(13,24,88,.28); transform:translateX(-50%); }
.paiwei-question-timer::after { position:absolute; inset:8px; border-radius:50%; content:''; background:#f2f1f4; }
.paiwei-question-timer strong { position:relative; z-index:1; display:flex; width:100%; height:100%; align-items:center; justify-content:center; margin:0; padding:0; color:#16151f; font-size:clamp(42px,13vw,78px); font-style:normal; font-weight:900; line-height:1; text-align:center; }
.paiwei-question-number { display:flex; width:clamp(150px,40%,205px); aspect-ratio:267 / 56; align-items:center; justify-content:center; align-self:center; margin:0 auto 24px; color:#25202c; background:transparent url('../../static/images/livequiz/start/question_bg.png') center/contain no-repeat; font-size:clamp(16px,4.2vw,27px); line-height:1; text-align:center; }
.paiwei-question-title { display:flex; min-height:130px; align-items:center; justify-content:center; margin:0 3% 27px; color:#171722; font-size:clamp(18px,4.7vw,31px); font-weight:700; line-height:1.3; text-align:center; }
.paiwei-answer-list { display:flex; flex-direction:column; gap:20px; }
.paiwei-answer-option { position:relative; display:flex; width:100%; min-height:clamp(76px,18vw,110px); align-items:center; padding:10px 7%; overflow:hidden; box-sizing:border-box; border:0; border-radius:999px; color:#171722; background:transparent url('../../static/images/livequiz/start/ans_bg.png') center/100% 100% no-repeat; cursor:pointer; font:inherit; font-size:clamp(18px,4.8vw,31px); font-weight:700; line-height:1.35; text-align:left; }
.paiwei-answer-option:disabled { cursor:default; }
.paiwei-answer-option.correct { color:#171722; background:transparent url('../../static/images/livequiz/start/my_correct_ans.png') center/100% 100% no-repeat; }
.paiwei-answer-option.wrong { color:#171722; background:transparent url('../../static/images/livequiz/start/my_wrong_ans.png') center/100% 100% no-repeat; }
.paiwei-answer-text { display:flex; min-width:0; align-self:stretch; align-items:center; padding-right:48px; overflow:visible; white-space:normal; }
.paiwei-answer-option > img { position:absolute; top:50%; right:5%; width:42px; height:42px; object-fit:contain; transform:translateY(-50%); }
.paiwei-result-popup { position:fixed; z-index:140; inset:0; }
.paiwei-result-popup-mask { position:absolute; inset:0; }
.paiwei-result-popup-dialog { position:absolute; top:11.5vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.paiwei-result-popup-header { position:relative; z-index:2; }
.paiwei-result-popup-header > img { display:block; width:100%; }
.paiwei-result-popup-header h2 { position:absolute; top:68%; right:10%; left:10%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(32px,9.5vw,67px); font-weight:900; line-height:1; letter-spacing:-.05em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.paiwei-result-popup-card { position:relative; margin-top:-5.5%; }
.paiwei-result-popup-card-bg { display:block; width:100%; }
.paiwei-result-popup-content { position:absolute; inset:0; display:flex; box-sizing:border-box; flex-direction:column; align-items:center; padding:13% 7.5% 8%; }
.paiwei-result-message { min-height:2.2em; margin:0; color:#fff; font-size:clamp(15px,4.1vw,30px); font-weight:500; line-height:1.12; text-align:center; }
.paiwei-result-message strong { color:#ffde00; font-weight:800; }
.paiwei-result-hero { display:block; width:100%; max-width:620px; min-height:0; flex:1 1 auto; margin:1% auto 0; object-fit:contain; transform:scale(1.15); transform-origin:center bottom; }
.paiwei-result-scores { position:relative; display:grid; width:100%; grid-template-columns:1fr 1fr; margin-top:1%; aspect-ratio:887 / 203; align-items:center; }
.paiwei-result-scores > img { position:absolute; inset:0; width:100%; height:100%; object-fit:fill; }
.paiwei-result-score { position:relative; z-index:1; display:flex; min-width:0; flex-direction:column; align-items:center; justify-content:center; color:#fff; text-align:center; }
.paiwei-result-score + .paiwei-result-score { border-left:1px solid rgba(255,255,255,.65); }
.paiwei-result-score span { font-size:clamp(13px,3.5vw,25px); font-weight:500; line-height:1.1; white-space:nowrap; }
.paiwei-result-score-number { display:flex; align-items:center; justify-content:center; gap:5px; margin-top:3%; }
.paiwei-result-score-number img { width:clamp(18px,5vw,36px); height:clamp(18px,5vw,36px); object-fit:contain; }
.paiwei-result-score strong { color:#ffcb00; font-size:clamp(25px,7.5vw,54px); font-style:italic; font-weight:900; line-height:.88; text-shadow:0 2px 1px rgba(113,50,0,.45); }
.paiwei-result-actions { display:flex; width:100%; align-items:center; justify-content:space-between; gap:4%; margin-top:5%; }
.paiwei-result-actions button { position:relative; display:block; width:48%; padding:0; border:0; background:transparent; cursor:pointer; font:inherit; }
.paiwei-result-actions img { display:block; width:100%; }
.paiwei-result-actions span { position:absolute; top:51%; right:6%; left:6%; transform:translateY(-50%); color:#fff; font-size:clamp(17px,4.7vw,34px); font-weight:900; line-height:1; text-align:center; text-shadow:0 3px 2px rgba(4,3,28,.8); text-transform:uppercase; white-space:nowrap; }
.paiwei-result-close { display:block; width:clamp(42px,13vw,96px); margin:3% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.paiwei-result-close img { display:block; width:100%; }

.paiwei-buy-popup { position:fixed; z-index:120; inset:0; }
.paiwei-buy-popup-mask { position:absolute; inset:0; }
.paiwei-buy-popup-dialog { position:absolute; top:12.2vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.paiwei-buy-popup-header { position:relative; z-index:2; }
.paiwei-buy-popup-header > img { display:block; width:100%; }
.paiwei-buy-popup-header h2 { position:absolute; top:68%; right:10%; left:10%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(25px,6.6vw,48px); font-weight:900; line-height:1; letter-spacing:-.035em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.paiwei-buy-popup-card { position:relative; margin-top:-5.5%; }
.paiwei-buy-popup-card-bg { display:block; width:100%; }
.paiwei-buy-popup-content { position:absolute; inset:0; display:flex; align-items:center; box-sizing:border-box; flex-direction:column; padding:12% 8% 7%; }
.paiwei-buy-popup-content > p { width:90%; margin:0; color:#fff; font-size:clamp(15px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.paiwei-buy-popup-content > p span { display:block; }
.paiwei-buy-popup-content > p strong { color:#ffde00; font-weight:800; }
.paiwei-buy-popup-hero { display:block; width:72%; object-fit:contain; }
.paiwei-buy-popup-option { position:relative; width:38%; min-width:132px; overflow:hidden; border:0; border-radius:15px; padding:3% 2% 6%; background:#24213e; color:#fff; cursor:pointer; font:inherit; }
.paiwei-buy-popup-option::before { position:absolute; inset:0; content:''; border:1px solid rgba(255,255,255,.05); border-radius:inherit; background:linear-gradient(180deg,rgba(255,255,255,.08),transparent 55%); pointer-events:none; }
.paiwei-buy-popup-option > img:not(.paiwei-buy-popup-option-bg) { position:relative; z-index:1; display:block; width:56%; margin:0 auto; }
.paiwei-buy-popup-option-bg { position:absolute; inset:0; width:100%; height:100%; opacity:.52; object-fit:cover; }
.paiwei-buy-popup-option span { position:relative; z-index:1; display:block; margin-top:1%; color:#fff; font-size:clamp(13px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.paiwei-buy-popup-balance { display:flex; align-items:center; justify-content:center; gap:6px; margin-top:20px; color:#ffe878; font-size:clamp(14px,4.2vw,30px); font-weight:500; line-height:1; text-align:center; }
.paiwei-buy-popup-balance img { width:clamp(22px,6vw,44px); height:clamp(22px,6vw,44px); object-fit:contain; }
.paiwei-buy-popup-balance strong { color:#fff; font-size:1.05em; }
.paiwei-buy-popup-close { display:block; width:clamp(42px,13vw,96px); margin:5% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.paiwei-buy-popup-close img { display:block; width:100%; }

@keyframes countdownPop {
  0% { transform:scale(0); opacity:0; }
  50% { transform:scale(1.2); opacity:1; }
  100% { transform:scale(1); opacity:0; }
}

@media (min-width:760px) {
  .paiwei-page-title { margin-bottom:72px; }
  .paiwei-score-player > img { width:108px; height:108px; }
  .paiwei-question-card { min-height:920px; }
}
</style>



// WEBPACK FOOTER //
// src/page/paiwei.vue